/* eslint-disable max-len */
/* eslint-disable no-eval */
/* eslint-disable nordic/i18n-jsx-no-literals */
const React = require('react');
const { useDebounce } = require('../utils/debounce');
const { brickCreationScript } = require('./constants');

const View = ({
  publicKey,
  theme,
  paymentMethod,
  maxInstallments,
  showTitle = true,
  showPaymentButton = true,
  submitTitle,
  language,
  customVariables,
  customTexts,
  payerInfo,
}) => {
  const debounceProps = [
    useDebounce(publicKey, 2000),
    useDebounce(theme, 2000),
    useDebounce(language, 2000),
    useDebounce(showPaymentButton, 2000),
    useDebounce(showTitle, 2000),
    useDebounce(maxInstallments, 2000),
    useDebounce(paymentMethod, 2000),
  ];
  const finalSubmitTitle = useDebounce(submitTitle, 2000);

  React.useEffect(() => {
    const getUserCustomInputs = () => {
      let customVariablesInput = {};
      let textsInput = {};
      let payerInput = {};

      try {
        customVariablesInput = JSON.parse(customVariables);
        textsInput = JSON.parse(customTexts);
        payerInput = JSON.parse(payerInfo);
      // eslint-disable-next-line no-empty
      } catch (e) {}

      return {
        customVariables: customVariablesInput,
        texts: textsInput,
        payer: payerInput,
      };
    };

    const userCustomInputs = getUserCustomInputs();

    window.cardPaymentBricksProps = {
      publicKey: publicKey || 'TEST-850db05a-5f8d-4c89-ab79-f44a7b2d224e',
      theme: theme || 'default',
      formSubmit: finalSubmitTitle || 'Pagar',
      language: language || 'pt-BR',
      hidePaymentButton: !showPaymentButton || false,
      hideFormTitle: !showTitle || false,
      maxInstallments: maxInstallments || 1,
      paymentMethod: paymentMethod || [],
      customVariables: userCustomInputs.customVariables,
      texts: userCustomInputs.texts,
      payer: userCustomInputs.payer,
    };
    setTimeout(() => {
      window.eval(brickCreationScript);
    }, 1000);
  }, [
    ...debounceProps,
    customVariables,
    customTexts,
    payerInfo,
  ]);

  React.useEffect(() => {
    const mpScript = document.createElement('script');
    mpScript.src = 'https://sdk.mercadopago.com/js/v2';
    document.body.appendChild(mpScript);
    return () => {
      document.body.removeChild(mpScript);
    };
  }, []);
  return (
    <>
      <div id="cardPaymentBrick_container" />
    </>
  );
};

module.exports = View;
